import { seoResolver } from "../../modules/app-route";
import { AppRoutes } from "../../modules/app-route/models/app-route.model";

export const LINKS_ROUTES: AppRoutes = [
    {
        path: "",
        loadComponent: () => import('./components/links-carousel/links-carousel.component').then(mod => mod.LinksCarouselComponent),
        outlet: "carousel"
    },
    {
        path: "",
        loadComponent: () => import('./components/links-home/links-home.component').then(mod => mod.LinksHomeComponent),
        title: 'YSTM - Links',
        data: {
            meta: {
                description: 'Informationen und Links zu Organisationen, die mit dem Yachtclub Steinhuder Meer oder seinen Veranstaltungen in Beziehung stehen'
            }
        },
        resolve: { seo: seoResolver },
    },
    {
        path: '**',
        redirectTo: '',
        pathMatch: 'full'
    }
];